import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { isBoolean } from 'lodash';
import { cloneElement, useEffect, useRef, useState } from 'react';
import './style.scss';

interface IProps {
  title: string;
  fontSize?: number;
  fontFamily?: string;
  placement?: TooltipPlacement;
  children: React.ReactElement;
}

export const AutoTooltip = (props: IProps) => {
  const {
    title,
    placement,
    children,
    fontSize = 12,
    fontFamily = 'MonaSans-Regular',
  } = props;
  const contentElementRef = useRef<HTMLSpanElement>(null);
  const [show, setShow] = useState<boolean>();

  useEffect(() => {
    const contentElement = contentElementRef.current;
    if (!contentElement) {
      return;
    }

    const containerWidth = contentElement.parentElement?.offsetWidth;
    if (!containerWidth) {
      return;
    }

    const textWidth = getTextWidth(title, `${fontSize}px ${fontFamily}`);
    if (textWidth > containerWidth) {
      setShow(true);
      return;
    }
    setShow(false);
  }, [contentElementRef]);

  if (isBoolean(show)) {
    return (
      <Tooltip
        title={show ? title : undefined}
        placement={placement}
        overlayClassName="tooltip-style"
      >
        {children}
      </Tooltip>
    );
  }

  return <> {cloneElement(children, { ref: contentElementRef })}</>;
};

function getTextWidth(text: string, font: string) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) {
    return 0;
  }
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}
